import { Box, Button, LinearProgress, Typography } from "@mui/material";
import React from "react";

const GardenSetupSummary = ({ steps, onSetupClick }) => {
  const totalSteps = steps.length;
  const completedSteps = steps.filter((step) => step.isDone).length;

  return (
    <Box
      style={{
        maxWidth: "500px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
        border: "1px solid rgba(0,0,0,0.3)",
        borderRadius: "1rem",
        alignSelf: "center",
        padding: "1rem",
        display: "flex",
        //space between
        justifyContent: "space-between",
      }}
    >
      <Box
        style={{
          flex: 3,
          marginRight: "2rem",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Garden Setup
        </Typography>
        {/* completed / total */}
        <Typography variant="subtitle1" gutterBottom>
          {completedSteps} / {totalSteps} completed
        </Typography>
        <LinearProgress
          variant="determinate"
          color="secondary"
          value={(completedSteps / totalSteps) * 100 || 10}
          sx={{ mb: 2 }}
        />
      </Box>
      {/* Setup button */}
      <Button
        variant="contained"
        color="secondary"
        style={{ maxHeight: "3rem", alignSelf: "center" }}
        onClick={onSetupClick}
      >
        Setup
      </Button>
    </Box>
  );
};

export default GardenSetupSummary;
